const theme = {
  // Temp fonts
  fonts: {
    title: "Space Grotesk, sans-serif",
    main: "Space Grotesk, sans-serif"
  },
  // Colors for layout
  colors: {
    // primary1: "#FFE3D8",
    primary1: "#fff",
    primary2: "#64FFDA",
    background1: "#0A043C", 
    background2: "#0F044C", 
    accent1: "hsl(34.9,98.6%,72.9%)",
    button: "hsl(205.1,100%,36.1%)",
    background3: "hsl(232.7,27.3%,23.7%)",
    links: "#64FFDA",
    backgroundhover1: "rgb(19,48,64)"
  },
  // Breakpoints for responsive design
  breakpoints: {
    sm: 'screen and (max-width: 640px)',
    md: 'screen and (max-width: 768px)',
    lg: 'screen and (max-width: 1024px)',
    xl: 'screen and (max-width: 1280px)'
  },
}

export default theme;